(function () {

    'use strict';

    angular.module('app.contactus', []);

})();


// WEBPACK FOOTER //
// ./app/contactus/contactus.module.js